import script from "./CourseDescriptionComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseDescriptionComponent.vue?vue&type=script&setup=true&lang=js"

import "./CourseDescriptionComponent.vue?vue&type=style&index=0&id=7dddb975&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dddb975"]])

export default __exports__